import { FormGroup } from '@angular/forms';
import { Config } from './ui-config';

export enum FormControlValueChangedAction {
  ValueChanged = 'valueChanged',
  OnEditCSV = 'onEditCSV',
  OnUpdateCsv = 'onUpdateCSV',
  CSVUpdated = 'CSVUpdated',
  DictValueChanged = 'dictValueChanged',
  /** Emitted after user confirms “reset constraints to defaults” (model constraints drag-drop). */
  ConstraintsResetToDefaults = 'constraintsResetToDefaults',
}

export interface FormControlValueChangedEvent {
  formGroup?: FormGroup;
  property?: string;
  action?: FormControlValueChangedAction;
  dictKey?: string;
  childProp?: string;
  childFormGroup?: FormGroup;
  config?: Config;
}
